import { Button, FormControlLabel, makeStyles, Radio, RadioGroup } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import moment from 'moment';
import { useEffect, useState } from 'react';
import ExcelFile from 'react-export-excel/dist/ExcelPlugin/components/ExcelFile';
import ExcelColumn from 'react-export-excel/dist/ExcelPlugin/elements/ExcelColumn';
import ExcelSheet from 'react-export-excel/dist/ExcelPlugin/elements/ExcelSheet';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { bbcBoxUpdate, getBbcOrdersByTime } from '../../actions/bbcOrderManagamentActions';
import { handleBbcOrderManagement, showAlertSnackbar } from '../../reducers/uiSlice';
import FullscreenLoading from '../Common/FullscreenLoading';
import UniDialog from '../Common/UniDialog';
import DownloadPattern from './DownloadPattern';
import UpdatePattern from './UpdatePattern';


const useStyles = makeStyles((theme) => ({
    itemLine: {
        marginTop: 8
    },
    itemTitle: {
        marginRight: 3
    },
    paraph: {
        marginTop: 16
    },
    excelDownload: {
        textAlign: "right",
        marginTop: 12,
        marginBottom: 12
    }
}));

function BbcOrderManagement() {
    const { t } = useTranslation('bbcOrderManagement');
    const dispatch = useDispatch();
    const classes = useStyles();

    const open = useSelector(state => state.ui.openBbcOrder);
    const loading = useSelector(state => state.bbcOrderManagementReducer.bbcBoxUpdateLoading || state.bbcOrderManagementReducer.getBbcOrdersByTimeLoading);

    const [index, setIndex] = useState('update_status');
    const [params, setParams] = useState({});
    const [openSummary, setOpenSummary] = useState(false);
    const [summary, setSummary] = useState({});
    const [queryList, setQueryList] = useState([]);

    const handleParams = (obj) => {
        setParams(obj);
    }

    const handleUpdate = () => {
        dispatch(bbcBoxUpdate(params))
            .then((res) => {
                if (res?.UNIFailedDatas?.length > 0 || res?.GVFailedDatas?.length > 0) {
                    const arr = params.data.split(',');
                    const total = arr.length;
                    let success = total;
                    arr.filter((no) => {
                        if (res.UNIFailedDatas.includes(no) || res.GVFailedDatas.includes(no)) {
                            success--;
                        }
                    })
                    setSummary({
                        total: total,
                        success: success,
                        uniFail: res.UNIFailedDatas.length,
                        gvFail: res.GVFailedDatas.length,
                        UNIFailedDatas: res.UNIFailedDatas.map((no) => { return { 'no': no } }),
                        GVFailedDatas: res.GVFailedDatas.map((no) => { return { 'no': no } })
                    })
                    setOpenSummary(true);
                } else {
                    dispatch(showAlertSnackbar({ message: t('success'), type: 'success' }))
                }
            })
            .catch(() => {
                dispatch(showAlertSnackbar({ message: t('error'), type: 'error' }))
            })
    }

    const queryByTime = () => {
        const oneDay = 24 * 60 * 60; // hours * minutes * seconds
        const diffDays = Math.round(Math.abs((params.fromTS - params.toTS) / oneDay));
        if (diffDays > 1) {
            dispatch(showAlertSnackbar({ message: t('no_exceed_days'), type: "warning" }))
        } else {
        dispatch(getBbcOrdersByTime(params))
            .then((res) => {
                // if (res.length > 0) {
                //     res.map((parcel) => {
                //         parcel.create_time = moment(parcel.create_time * 1000).format('YYYY-MM-DD HH:mm:ss')
                //         parcel.ready_pickup_time = moment(parcel.ready_pickup_time * 1000).format('YYYY-MM-DD HH:mm:ss')
                //         parcel.picked_up_time = moment(parcel.picked_up_time * 1000).format('YYYY-MM-DD HH:mm:ss')
                //         parcel.gateway_out_time = moment(parcel.gateway_out_time * 1000).format('YYYY-MM-DD HH:mm:ss')
                //     })
                // }
                dispatch(showAlertSnackbar({ message: t('success'), type: 'success' }))
                // setQueryList(res);
            })
            .catch(() => {
                dispatch(showAlertSnackbar({ message: t('error'), type: 'error' }))
            })
        }
    }

    useEffect(() => {
        if (open) {
            setIndex('update_status');
            setQueryList([]);
        }

    }, [open])

    return (
        <UniDialog
            title={t('menu:bbc-order-management')}
            maxWidth='sm'
            fullWidth
            open={open}
            onClose={() => {
                dispatch(handleBbcOrderManagement(false))
            }}
            autoClose={false}
            disableDefaultButtons={true}
            buttons={index === 'update_status' ? [
                {
                    color: 'primary',
                    text: t('update_status'),
                    action: () => {
                        handleUpdate();
                    },
                    id: 'bbc-order-management-update',
                    disabled: !params.data
                }
            ] : [
                {
                    color: 'primary',
                    text: t('download'),
                    action: () => {
                        queryByTime();
                    },
                    id: 'bbc-order-management-query'
                }
                //     {
                //         color: 'primary',
                //         text: t('download'),
                //         action: () => { },
                //         id: 'bbc-order-management-download',
                //         type: 'download',
                //         data: queryList,
                //         disabled: !queryList?.length > 0
                // }
            ]}
        >
            <RadioGroup
                defaultValue={index}
                onChange={(e) => {
                    setParams({});
                    setIndex(e.target.value)
                }}
                style={{ display: 'flex', flexDirection: 'row' }}
            >
                <FormControlLabel
                    value={'update_status'}
                    control={<Radio />}
                    label={t('update_status')}
                />
                <FormControlLabel
                    value={'search_update'}
                    control={<Radio />}
                    label={t("search_update")}
                />
            </RadioGroup>
            {
                index === 'update_status' ?
                    <UpdatePattern handleParams={handleParams} /> :
                    <DownloadPattern handleParams={handleParams} />
            }
            <UniDialog
                title={t('update_summary')}
                maxWidth='sm'
                disableDefaultButtons
                open={openSummary}
                onClose={() => setOpenSummary(false)}
            >
                <Alert variant="filled" severity="error">{t('alert')}</Alert>
                <div className={classes.itemLine}><span className={classes.itemTitle}>{t('total_uploaded')}</span><span>{summary.total}</span></div>
                <div className={classes.itemLine}><span className={classes.itemTitle}>{t('update_succeeded')}</span><span>{summary.success}</span></div>
                <div className={classes.itemLine}><span className={classes.itemTitle}>{t('uni_failed')}</span><span>{summary.uniFail}</span></div>
                <div className={classes.itemLine}><span className={classes.itemTitle}>{t('gv_failed')}</span><span>{summary.gvFail}</span></div>
                <div className={classes.paraph}>{t("download_paragh")}</div>
                <div className={classes.excelDownload}>
                    <ExcelFile
                        element={
                            <Button
                                color='primary'
                                variant="contained"
                                id='bbcordermanagement-summarydownload-button'
                                onClick={() => setOpenSummary(false)}
                            >
                                {t('common:yes')}
                            </Button>
                        }
                    >
                        <ExcelSheet data={summary?.UNIFailedDatas || []} name={'UNIFailedData'}>
                            <ExcelColumn label='no' value='no' />
                        </ExcelSheet>
                        <ExcelSheet data={summary?.GVFailedDatas || []} name={'GVFailedData'}>
                            <ExcelColumn label='no' value='no' />
                        </ExcelSheet>
                    </ExcelFile>
                </div>
            </UniDialog>
            <FullscreenLoading open={loading} />
        </UniDialog>
    );
}

export default BbcOrderManagement;